import React from "react";
import { clsx } from "clsx";

export interface Tab {
    id: string;
    label: string;
    content: React.ReactNode;
}

export interface TabsProps {
    tabs: Tab[];
    activeTabId: string;
    onTabChange: (tabId: string) => void;
    className?: string;
}

export const Tabs: React.FC<TabsProps> = ({ tabs, activeTabId, onTabChange, className }) => {
    const activeTab = tabs.find((tab) => tab.id === activeTabId) || tabs[0];

    return (
        <div className={clsx("w-full", className)}>
            <div className="border-b border-neutral-border dark:border-neutral-border/30">
                <nav className="flex space-x-1" aria-label="Tabs">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => onTabChange(tab.id)}
                            className={clsx(
                                "px-5 py-3 text-sm font-bold tracking-wide transition-all duration-200 border-b-2",
                                activeTabId === tab.id
                                    ? "border-gold text-primary dark:text-gold-light"
                                    : "border-transparent text-neutral-secondary hover:text-neutral-ink dark:hover:text-white hover:border-neutral-border dark:hover:border-white/20"
                            )}
                            aria-selected={activeTabId === tab.id}
                            role="tab"
                        >
                            {tab.label}
                        </button>
                    ))}
                </nav>
            </div>
            <div className="mt-4">{activeTab?.content}</div>
        </div>
    );
};

